import { CheckCircleIcon } from 'lucide-react';
import type { BenefitNotification } from '../hooks/usePurchaseNotifications';
type PurchaseNotificationProps = {
  notification: BenefitNotification;
  isVisible: boolean;
};
export function PurchaseNotification({
  notification,
  isVisible
}: PurchaseNotificationProps) {
  return <aside className={`pointer-events-none fixed bottom-4 left-4 z-30 max-w-[calc(100vw-2rem)] transition-[transform,opacity] duration-200 ease-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-3 opacity-0'}`} aria-live="polite" aria-atomic="true" data-id="element-127" data-mp="199o3xzw5vfcw">
      <div className="flex items-center gap-2.5 rounded-xl border border-emerald-200 bg-white/95 px-3 py-2.5 shadow-[0_8px_22px_rgba(11,31,59,0.14)] backdrop-blur-sm" data-id="element-128" data-mp="21vr2kdp6nvda">
        <div className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-700" data-id="element-129" data-mp="1swcchfcxhmtb">
          <CheckCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-130" data-mp="lgz8lwce2g1v" />
        </div>
        <p className="text-xs font-bold leading-snug text-[#0B1F3B]" data-id="element-131" data-mp="hgfaoqjzr8eo">{notification.detail}</p>
      </div>
    </aside>;
}